import type { SectionConfig } from '@/mocks/questionnaire';
import type { Answers } from '@/pages/home/types';
import SectionCard from '@/pages/home/components/SectionCard';
import FieldRenderer from '@/pages/home/components/FieldRenderer';

interface ConfigStepProps {
  sections: SectionConfig[];
  answers: Answers;
  onAnswer: (name: string, value: string | string[]) => void;
}

export default function ConfigStep({ sections, answers, onAnswer }: ConfigStepProps) {
  return (
    <>
      {sections.map((section, index) => (
        <SectionCard key={section.title} index={index + 1} title={section.title} note={section.note}>
          {section.fields.map((field) => (
            <FieldRenderer key={field.name} field={field} answers={answers} onAnswer={onAnswer} />
          ))}
        </SectionCard>
      ))}
    </>
  );
}